import { setClickInsightServiceError } from "@/lib/util";
import style from "@/styles/pages/Error/Error.module.css";
import { useEffect } from "react";

export default function CustomError() {

  let title="Sorry, we’re experiencing some issues";
  let content = <></>

  const handleExit = () => {
    window.location.href = 'https://www.meridiancu.ca/';
  };

  useEffect(() => {
    setClickInsightServiceError();
  }, [])

  return (
    <main aria-labelledby="main-content">
      <div className="flex flex-col max-xs:px-3 items-center max-md:mt-20">
        <div className={style.errHeading}>
          <div>
            <h1>{title}</h1>
            <p className="mt-3">{content}</p>
          </div>
        </div>
        <div className="mb-5">
          <button className="primary mt-5 w-full  h-11 px-6" onClick={handleExit}>
            Exit Application
          </button>
        </div>
      </div>
    </main>
  );
}
